import { createActions } from 'utils/actions';

/**
 * Redux actions for fetching the Questionnaire information.
 *
 * @type {Object}
 */
export const fetchQuestionnaireInfo = createActions('acaReporting', 'FETCH_QUESTIONNAIRE_INFO', {
    asPromise: true,
});

/**
 * Redux actions for fetching the Questionnaire status.
 *
 * @type {Object}
 */

/**
 * Redux actions for fetching the Questionnaire Details.
 *
 * @type {Object}
 */
export const fetchQuestionnaireDetails = createActions(
    'acaReporting',
    'FETCH_QUESTIONNAIRE_DETAILS',
    {
        asPromise: true,
    }
);

/**
 * Redux actions for fetching the Questionnaire status.
 *
 * @type {Object}
 */

export const fetchQuestionnaireStatus = createActions(
    'acaReporting',
    'FETCH_QUESTIONNAIRE_STATUS',
    {
        asPromise: true,
    }
);

/**
 * Redux actions to set the Questionnaire status.
 *
 * @type {Object}
 */
export const setQuestionnaireStatus = createActions('acaReporting', 'SET_QUESTIONNAIRE_STATUS', {
    asPromise: true,
});

/**
 * Redux actions to update the Questionnaire status.
 *
 * @type {Object}
 */
export const updateQuestionnaireStatus = createActions(
    'acaReporting',
    'UPDATE_QUESTIONNAIRE_STATUS',
    {
        asPromise: true,
    }
);

/**
 * Redux actions for fetching the Questions.
 *
 * @type {Object}
 */
export const fetchQuestions = createActions('acaReporting', 'FETCH_QUESTIONS', {
    asPromise: true,
});

/**
 * Redux actions for fetching the answer status of a Question.
 *
 * @type {Object}
 */
export const fetchAnswerList = createActions('acaReporting', 'FETCH_ANSWER_LIST', {
    asPromise: true,
});

/**
 * Redux actions for creating the answer of a Question.
 *
 * @type {Object}
 */
export const createAnswer = createActions('acaReporting', 'CREATE_ANSWER', {
    asPromise: true,
});

/**
 * Redux actions for updating the answer of a Question.
 *
 * @type {Object}
 */
export const updateAnswer = createActions('acaReporting', 'UPDATE_ANSWER', {
    asPromise: true,
});

/**
 * Redux actions to delete Answer.
 *
 * @type {Object}
 */
export const deleteAnswer = createActions('acaReporting', 'DELETE_ANSWER', {
    asPromise: true,
});

/**
 * Redux actions for fetching the answer of a Questionnaire.
 *
 * @type {Object}
 */
export const fetchAllAnswers = createActions('acaReporting', 'FETCH_ALL_ANSWERS', {
    asPromise: true,
});

/**
 * Redux actions for fetching the Eligible Questionnaire years.
 *
 * @type {Object}
 */
export const fetchQuestionnaireEligibility = createActions(
    'acaReporting',
    'FETCH_QUESTIONNAIRE_ELIGIBILITY',
    {
        asPromise: true,
    }
);

/**
 * Redux actions for fetching the Broker Details.
 *
 * @type {Object}
 *
 */
export const fetchBrokerDetails = createActions('acaReporting', 'FETCH_BROKER_DETAILS', {
    asPromise: true,
});

/**
 * Redux actions to create Company Partner consent.
 *
 * @type {Object}
 *
 */
export const createConsent = createActions('acaReporting', 'CREATE_CONSENT', {
    asPromise: true,
});

/**
 * Redux actions to fetch Company Partner consent details.
 *
 * @type {Object}
 *
 */
export const fetchConsentDetails = createActions('acaReporting', 'FETCH_CONSENT_DETAILS', {
    asPromise: true,
});

/**
 * Redux actions to fetch Company additional data.
 *
 * @type {Object}
 *
 */
export const fetchCompanyAdditionalData = createActions(
    'acaReporting',
    'FETCH_COMPANY_ADDITIONAL_DATA',
    {
        asPromise: true,
    }
);

/**
 * Redux actions to fetch Partner consents list.
 *
 * @type {Object}
 *
 */
export const fetchPartnerConsentsList = createActions(
    'acaReporting',
    'FETCH_PARTNER_CONSENTS_LIST',
    {
        asPromise: true,
    }
);

/**
 * Redux actions to set ACA tax year in Redis.
 *
 * @type {Object}
 *
 */
export const setAcaTaxYearInRedis = createActions('acaReporting', 'SET_ACA_TAX_YEAR_IN_REDIS', {
    asPromise: true,
});
